import { render, staticRenderFns } from "./JcdcTextarea.vue?vue&type=template&id=8919561e"
import script from "./JcdcTextarea.vue?vue&type=script&lang=ts"
export * from "./JcdcTextarea.vue?vue&type=script&lang=ts"
import style0 from "./JcdcTextarea.vue?vue&type=style&index=0&id=8919561e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports